export default function useConvertDate({date, withHour}) {

    const jsonDate = new Date(date);
    
    // const dateTimeStamp = jsonDate.getTime();  

    let convertTime = '';
    
    if (withHour) {
        convertTime = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short',day: '2-digit', hour: '2-digit', minute: '2-digit', hour12:false}).format(jsonDate);
    } else {
        convertTime = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'short',day: '2-digit'}).format(jsonDate);
    }
    
  return (convertTime )
}
